(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pittards-retail-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const roots = Array.from(document.querySelectorAll('.ps-nav-parent'));
    const groups = Array.from(document.querySelectorAll('.ps-group'));
    const mobile = window.matchMedia('(max-width: 1024px)');
    const syncGroups = () => {
      groups.forEach(group => { group.open = !mobile.matches; });
      roots.forEach(root => { root.open = false; });
    };
    syncGroups();
    mobile.addEventListener('change', syncGroups);
    document.addEventListener('toggle', event => {
      const target = event.target;
      if (target.matches('.ps-nav-parent') && target.open) {
        roots.forEach(root => { if (root !== target) root.open = false; });
      }
      if (mobile.matches && target.matches('.ps-group') && target.open) {
        target.closest('.ps-groups').querySelectorAll('.ps-group').forEach(group => {
          if (group !== target) group.open = false;
        });
      }
    }, true);
    document.addEventListener('click', event => {
      if (!mobile.matches && event.target.closest('.ps-group > summary')) {
        event.preventDefault();
      }
      roots.forEach(root => {
        if (root.open && !root.contains(event.target)) root.open = false;
      });
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const openRoot = roots.find(root => root.open && root.contains(document.activeElement))
        || roots.find(root => root.open);
      if (!openRoot) return;
      event.preventDefault();
      roots.forEach(root => { root.open = false; });
      openRoot.querySelector('summary').focus();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pittards-xs-sizing-help"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded',()=>{
 const select=document.getElementById('product-select'),note=document.getElementById('pittards-xs-help');
 if(!select||!note)return;
 const sync=()=>{const title=select.options[select.selectedIndex]?.textContent.trim().toLowerCase()||'';note.hidden=!/(^|\/)\s*(extra small|xs)\s*($|\/)/.test(title)};
 select.addEventListener('change',sync);sync();
});
  } catch(e) { console.error(e); }
})();

})();
